import Chance from 'chance';
import moment from 'moment-timezone';
const chance = new Chance();
export const getFakeDate = (fieldType, state, { dateOptions } = {}) => {
    let val;
    // We need to clone the date options because chanceJS will mutate it otherwise.
    const safeDateOptions = Object.assign({}, dateOptions);
    switch (fieldType) {
        case `timer`:
            const date = moment(chance.date(safeDateOptions));
            const fromMoment = moment(date);
            const toMoment = moment(date).add(1, `hours`);
            val = {
                total_time: toMoment.diff(fromMoment, `milliseconds`),
                times: {
                    from: {
                        date: fromMoment.format(`MM/DD/YYYY`),
                        hours: fromMoment.hours(),
                        minutes: fromMoment.minutes(),
                        am_pm: fromMoment.format(`A`)
                    },
                    to: {
                        date: toMoment.format(`MM/DD/YYYY`),
                        hours: toMoment.hours(),
                        minutes: toMoment.minutes(),
                        am_pm: toMoment.format(`A`)
                    }
                }
            };
            break;
        default:
            val = moment(chance.date(safeDateOptions)).valueOf();
            break;
    }
    return val;
};
